module.exports = __webpack_public_path__ + "static/media/file-import.edae9172.svg";